import { useQuery } from '@tanstack/react-query';
import { api } from './api.js';
import type { DownloadItem } from '@z9-store/core';

interface DownloadsResponse {
  readonly downloads: ReadonlyArray<DownloadItem>;
}

export function useDownloads() {
  return useQuery<ReadonlyArray<DownloadItem>>({
    queryKey: ['downloads'],
    queryFn: async () => (await api.get<DownloadsResponse>('/downloads')).downloads,
    staleTime: 5 * 60_000
  });
}

// Pure -- group by category preserving first-seen order.
export function groupByCategory(items: ReadonlyArray<DownloadItem>): Array<{ category: string; items: DownloadItem[] }> {
  const order: string[] = [];
  const byCat = new Map<string, DownloadItem[]>();
  for (const i of items) {
    if (!byCat.has(i.category)) {
      order.push(i.category);
      byCat.set(i.category, []);
    }
    byCat.get(i.category)!.push(i);
  }
  return order.map((category) => ({ category, items: byCat.get(category)! }));
}
